import { Component } from 'preact'
import axios from 'axios'
import EventCalendarRow from './EventCalendarRow'
import Phrase from '../../libs/translationsUtils/phrase'
import { z } from 'zod'
import { GetServerSideProps } from '../../server-middleware/context'
import WidgetContainer, { widgetContainerConfig } from '../widget-container'
import classNames from 'classnames'

interface Event {
  id: number
  type?: string
  startAt: number
  title: string
  destinationUrl: string
}

interface State {
  eventsList: Event[]
  isLoading: boolean
}

interface EventsCalendarWidgetProps {
  config: EventsCalendarWidgetConfig
  eventsList?: State['eventsList']
}

export const widgetName = 'event_calendar'

export const config = z.object({
  amount: z.number()
}).merge(widgetContainerConfig)

export type EventsCalendarWidgetConfig = z.infer<typeof config>

export const getServerSideProps: GetServerSideProps<EventsCalendarWidgetConfig, EventsCalendarWidgetProps> = async (_, config) => {
  return {
    config: config
  }
}

export class EventsCalendarWidget extends Component<EventsCalendarWidgetProps, State> {
  constructor (props: EventsCalendarWidgetProps) {
    super(props)
    this.state = {
      eventsList: props.eventsList || [],
      isLoading: false
    }
  }

  async componentDidMount () {
    if (this.state.eventsList.length) return
    this.setState({ isLoading: true })
    try {
      const res = await axios.get('/widget/eventsCalendar', {
        params: {
          maxResults: this.props.config.amount
        }
      })
      if (res.data) {
        this.setState({ eventsList: res.data, isLoading: false })
      }
    } catch (e) {
      this.setState({ isLoading: false })
    }
  }

  render () {
    const { config } = this.props
    const { eventsList, isLoading } = this.state
    const eventsCount = eventsList.length
    const showTwoColumns = (eventsCount === 4 || eventsCount === 2)

    return (
      <WidgetContainer
        config={config}
        widgetName='event-calendar'
      >
        <div className={classNames('full-width', 'Template-brand-featured', 'homepage-widget-wrapper', 'custom-event-calendar', 'widget', 'widget--event-calendar', 'qa-widget-event_calendar')}>
          <div className='sitewidth'>
            <div className='col event-calendar-container'>
              {
              !isLoading && (eventsCount > 0) &&
              (
                <div className={`event-calendar-wrapper ${showTwoColumns ? 'event-calendar-wrapper-two-column' : 'event-calendar-wrapper-three-column'}`}>
                  {eventsList.map(event => <EventCalendarRow key={event.id} {...event} />)}
                </div>
              )
            }
              {
              !isLoading && (eventsCount > 0) &&
              (
                <div>
                  <a href='/events' className='btn--cta btn--show-more'><Phrase p='events.show.more' m='Forum' /></a>
                </div>
              )
            }
            </div>
          </div>
        </div>
      </WidgetContainer>
    )
  }
}

export default EventsCalendarWidget
